import axios, { AxiosError } from 'axios';
import * as React from 'react';
import { requestListContacts } from '../asyncHelpers/listsService';
import { RequestStatus } from '../sic-lib/enums/RequestStatus';
import { ListContact, ListContactsRequest } from '../sic-lib/types/ListContact';
import { useAppDispatch } from '../store/hooks';
import { createToast } from '../store/notify';
import { createErrorToast } from '../utils/notifyHelpers';

/**
 * useAsyncGetContactTags
 *
 * @description
 * React hook providing request state management and cancellation for the
 * requestContactTags HTTP request
 */
export default function useAsyncGetListContactsLite() {
    const request_token = axios.CancelToken.source();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
        return () => {
            request_token.cancel();
        };
    }, []);

    const [requestStatus, setRequestStatus] = React.useState<RequestStatus>(RequestStatus.none);

    const asyncGetListContacts = async (
        requestData: ListContactsRequest,
    ): Promise<ListContact[] | undefined> => {
        try {
            setRequestStatus(RequestStatus.active);

            const { data } = await requestListContacts(requestData, request_token.token);

            setRequestStatus(RequestStatus.success);

            return data || [];
        } catch (error: any) {
            if (!axios.isCancel(error)) {
                if (axios.isAxiosError(error)) {
                    const res = error as AxiosError;
                    if (res.response?.status === 400) {
                        setRequestStatus(RequestStatus.success);
                        return;
                    }
                }
                /* Notify user of failed http request */
                const toastData = createErrorToast(error.response.data);

                dispatch(createToast({ toastData }));

                /* Update state */
                setRequestStatus(RequestStatus.error);
            }
        }
    };

    return {
        requestStatus,
        asyncGetListContacts,
    };
}
